import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { SpecraButton, SpecraSpinner } from '@mono/ui-components/ensigns';
import { Testids } from '@mono/ui-selectors';
import { useParams, useSearchParams } from 'react-router-dom';
import { RegistryRecordFrame } from '../RegistryRecordFrame';
import { AwardsChart } from './govorg/AwardsChart';
import { GovOrgLogTouchpoint, useGovOrgIntel } from './govorg/GovOrgActions';
import { GovOrgHeader } from './govorg/GovOrgHeader';
import { govOrgRail } from './govorg/govOrgRail';
import { useGovernmentOrg } from './govorg/hooks';
import { PeopleInOut } from './govorg/PeopleInOut';
import { readAwardScope, writeAwardScope } from './govorg/scope';
import { WhatTheyAskFor } from './govorg/WhatTheyAskFor';
import { WhereTheyShowUp } from './govorg/WhereTheyShowUp';
export function GovernmentOrgRecordPage() {
    const { id = '' } = useParams();
    const [params, setParams] = useSearchParams();
    const scope = readAwardScope(params);
    const queries = useGovernmentOrg(id, scope);
    const dossier = queries.dossier.data;
    const intel = useGovOrgIntel(dossier?.orgId ?? '', dossier?.name ?? '');
    const status = queries.dossier.isPending ? 'loading' : queries.dossier.isError ? 'error' : dossier ? 'ready' : 'unavailable';
    const docsState = queries.documents.isError ? /*#__PURE__*/ _jsx(SpecraButton, {
        variant: "ghost",
        onClick: ()=>void queries.documents.refetch(),
        children: "Retry loading documents"
    }) : queries.documents.isPending ? /*#__PURE__*/ _jsx(SpecraSpinner, {
        label: "Loading documents"
    }) : undefined;
    return /*#__PURE__*/ _jsx(RegistryRecordFrame, {
        kindLabel: "Government Orgs",
        tab: "govorgs",
        title: dossier?.name,
        status: status,
        error: queries.dossier.error,
        onRetry: ()=>void queries.dossier.refetch(),
        header: dossier && /*#__PURE__*/ _jsx(GovOrgHeader, {
            dossier: dossier,
            actions: /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(GovOrgLogTouchpoint, {
                        dossier: dossier,
                        people: queries.people.data?.people ?? []
                    }),
                    intel.action
                ]
            })
        }),
        railSections: dossier ? govOrgRail(dossier, queries.documents.data, intel.section, docsState) : undefined,
        children: dossier && /*#__PURE__*/ _jsxs("div", {
            className: "space-y-8",
            "data-testid": Testids.registryGovOrg.page,
            children: [
                /*#__PURE__*/ _jsx(WhereTheyShowUp, {
                    cards: dossier.appearances
                }),
                queries.awards.isPending ? /*#__PURE__*/ _jsx(SpecraSpinner, {
                    label: "Loading awards"
                }) : queries.awards.isError ? /*#__PURE__*/ _jsx(SpecraButton, {
                    variant: "secondary",
                    onClick: ()=>void queries.awards.refetch(),
                    children: "Retry loading awards"
                }) : /*#__PURE__*/ _jsx(AwardsChart, {
                    series: queries.awards.data,
                    fy: queries.fy,
                    scope: scope,
                    onScopeChange: (next)=>setParams(writeAwardScope(params, next))
                }),
                queries.people.isPending ? /*#__PURE__*/ _jsx(SpecraSpinner, {
                    label: "Loading registry people"
                }) : queries.people.isError ? /*#__PURE__*/ _jsx(SpecraButton, {
                    variant: "secondary",
                    onClick: ()=>void queries.people.refetch(),
                    children: "Retry loading registry people"
                }) : /*#__PURE__*/ _jsx(PeopleInOut, {
                    people: queries.people.data.people
                }),
                /*#__PURE__*/ _jsx(WhatTheyAskFor, {
                    dossier: dossier
                }),
                intel.dialog
            ]
        })
    });
}
